import axios from 'axios';

const API_URL = 'https://pojwd7csd2.execute-api.us-east-1.amazonaws.com';
const API_URL2 = 'https://konselior.herokuapp.com';
// if (location.href.indexOf('localhost:3000') > -1) {
//     // API_URL = 'http://localhost:8080'
//     API_URL = 'https://kontalk-stage.herokuapp.com';
//   } else if (location.href.indexOf('kontalk-stage.surge.sh') > -1) {
//     API_URL = 'https://kontalk-stage.herokuapp.com';
//   }

export class APIService {
  constructor() {
  }

  getCustomer(userId) {
    const encodedUserId = btoa(userId);
    const url = `${API_URL2}/seller/customer/${encodedUserId}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getVendasPdvByVendedor(customerId, sellerName, dataInicio, dataFim) {
    const url = `${API_URL}/dev/vendas/pdv/${customerId}/${sellerName}?inicio=${dataInicio}&fim=${dataFim}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getClientesNovos(customerId, sellerName, dataInicio, dataFim) {
    const url = `${API_URL}/dev/vendas/${customerId}/vendedor/${sellerName}/clientes/novos?inicio=${dataInicio}&fim=${dataFim}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getClientesRecompra(customerId, sellerName, dataInicio, dataFim) {
    const url = `${API_URL}/dev/vendas/${customerId}/vendedor/${sellerName}/clientes/recompra?inicio=${dataInicio}&fim=${dataFim}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getCampanhaStats(customerId, sellerName, dataInicio, dataFim) {
    const url = `${API_URL}/dev/campanha/${customerId}/${sellerName}?inicio=${dataInicio}&fim=${dataFim}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }

  getClientesPorVendedor(customerId, sellerName) {
    const url = `${API_URL}/dev/clientes/${customerId}/${sellerName}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data).catch(err => console.log(err));
  }

  getCampaign(id) {
    const url = `${API_URL2}/campaign/${id}`;
    return axios.get(url, { crossDomain: true }).then(response => response.data);
  }
}
